export default class EmployeeHistory {
    constructor({
        Id,
        IdEmployee,
        Fdate,
        Tdate,
        IdBranch,
        Branch,
        IdTeam,
        Team,
        IdRank,
        Rank,
        DateHistory,
    }) {
        this.Id = Id;
        this.IdEmployee = IdEmployee;
        this.Fdate = Fdate;
        this.Tdate = Tdate;
        this.IdBranch = IdBranch;
        this.Branch = Branch;
        this.IdTeam = IdTeam;
        this.Team = Team;
        this.IdRank = IdRank;
        this.Rank = Rank;
        this.DateHistory = DateHistory;
    }

    isNew() {
        return (this.Id == undefined) || (this.Id < 1) || (this.Id.toString().toUpperCase() == "NEW");
    }

    getFdate() {
        return this.Fdate ? new Date(this.Fdate) : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    }

    getTdate() {
        return this.Tdate ? new Date(this.Tdate) : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    }
}
